const ROOT = '/violation-management'

const violationTypeManagementPaths = {
  root: ROOT,
  AddViolation: `${ROOT}/add-violation`,
};

export default violationTypeManagementPaths;